<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>

    <div v-else>
      <v-card flat v-if="currentBusiness">
        <PrintViewBar v-if="customer" :showEmailBtn="showEmailBtn" :id="customer.id" type="invoice"
          :title="title" :postfix="`openInvoice?key=${currentBusiness.code}`" :name="currentBusiness.name"
          :email="customer.email" :obj="customer" :text="`${currentBusiness.name} Invoice click here to view`" />

        <v-container grid-list-lg>
          <v-card-text class="pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img class="logo" :src="currentBusiness.imageUrl" alt="" />
                </div>
                <div class=" headline font-weight-bold">
                  {{ currentBusiness.name }}
                </div>
              </v-flex>
            </v-layout>
            <v-layout row justify-space-between>
              <v-flex class="text-left text-capitalize  pt-0" xs6>
                <div class="font-weight-medium">
                  {{ currentBusiness.address }} {{ currentBusiness.city }},
                  <span class="text-uppercase">{{ currentBusiness.state }}
                  </span>
                  {{ currentBusiness.zip }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.phoneNumber }}
                </div>

              </v-flex>

              <v-spacer></v-spacer>


              <v-flex xs6 class="pt-0">
                <div class="text-right">
                  <div class="font-weight-medium text-lowercase">
                    {{ currentBusiness.email }}
                  </div>
                  <div class="font-weight-medium text-lowercase">
                    {{ currentBusiness.website }}
                  </div>
                </div>

              </v-flex>
            </v-layout>

            <span class="font-weight-bold mt-10">Date:</span> {{ currentDate | moment("MMM DD YYYY") }}
          </v-card-text>
          <v-card-text class="body-2 font-weight-light" v-if="currentClass">

            <div>Dear <span class="font-weight-bold">{{ customer.fatherName }}</span>,</div>

            <div class="mt-5">
              Parent/Guardian of: <span class="font-weight-bold">{{ student.fullName }}</span>
            </div>

            <div class="mt-5">
              Alhamdulillah your child <span class="font-weight-bold">{{ student.fullName }}</span> is currently
              enrolled in the <span class="font-weight-bold">{{ currentClass.name }}</span> at {{ currentBusiness.name
              }}. <span v-if="customer.balance !== 0">At present, there is an outstanding balance of <span
                  class="font-weight-bold">{{
                    customer.balance | currency }}/- </span> on your account. As you know, this program heavily relies on
                tuition fees to operate effectively.
                Unfortunately, the <span class="font-weight-bold">unpaid balance</span> is creating challenges,
                including delays in compensating our dedicated staff. We kindly request that you settle this balance as
                soon as possible.</span>
            </div>

            <div class="mt-5">
              <span v-if="customer.balance !== 0">Additionally, we</span> <span v-else>We </span> would like to bring to
              your attention that the current monthly fee for the program is
              <span class="font-weight-bold">{{ currentNotPayingClass.fee | currency }}/- </span>, while you are
              currently paying <span class="font-weight-bold">{{ currentNotPayingClass.parentPay | currency }}/- </span>
              per month. To help ease this transition, we are offering a <span class="font-weight-bold">$100</span>
              discount, bringing the monthly fee to <span class="font-weight-bold">{{ currentNotPayingClass.fee - 100 |
                currency }}/-</span>. Therefore, we kindly ask you to pay an additional <span
                class="font-weight-bold">{{ currentNotPayingClass.fee - 100 - currentNotPayingClass.parentPay |
                  currency }}/-</span> per month to cover the
              difference and ensure your payments align with the discounted fee.

            </div>

            <div class="mt-5">
              If, for any reason, you are unable to afford the adjusted fee, we humbly encourage you to consider
              applying for support through the <span class="font-weight-bold">Zakat Fund</span>. The masjid will begin
              collecting Zakat donations during
              Ramadan, specifically to assist families in need and to ensure that no child is deprived of this valuable
              program.
            </div>

            <div class="mt-5">
              Please remember, the masjid operates as a nonprofit organization and does not generate any profit from
              running these programs. In fact, we always fall short of covering our full expenses.
            </div>
            <div class="mt-5">
              We kindly urge you to either begin paying the full fee amount or explore other available options, such as
              the Zakat fund, to help sustain this program and support our staff.
            </div>
            <div class="mt-5">
              We greatly appreciate your attention to this matter and your continued support of the masjid and its
              efforts. May Allah (SWT) reward you for your understanding and generosity.
            </div>




            <div class="mt-5 font-weight-bold">
              JazakAllahu Khairan, Muhammadi Masjid Management
            </div>
<!-- 
            <div class="mt-10 font-weight-bold">
              Muhammadi Masjid Management
            </div> -->

          </v-card-text>
          <v-card-text v-else class="text-h3">
            No need to send the letter the fee's are upto date.
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";

import invoiceService from "@/modules/Invoice/service";
import customerService from "@/modules/Customer/service";
import studentService from "@/modules/Student/service.js";
import classService from "@/modules/Classes/service.js"
import Hashids from "hashids";
const hashids = new Hashids();
import { mapGetters, mapActions } from "vuex";

export default {
  name: "pending-invoice",
  data() {
    return {
      title: null,
      currentClass: null,
      currentNotPayingClass: null,
      currentDate: new Date,
      customer: null,
      showEmailBtn: false,
      isLoading: true,
      business: null,
      response: null,
      classes: [],
      Invoice: null,
      headers: [
        {
          text: "DATE",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        {
          text: "ID",
          align: "center",
          value: "qty",
          sortable: false,
        },
        {
          text: "AMOUNT",
          align: "right",
          value: "rate",
          sortable: false,
        },
        {
          text: "BALANCE",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    // formattedStudentNames() {
    //   const names = this.students.map(student => student.fullName);
    //   if (names.length > 1) {
    //     return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    //   } else {
    //     return names[0];
    //   }
    // },
  },
  async created() {
    await this.getStudents();

    await this.getCustomer();

    if (this.$route.meta.public) {
      await this.loadPublicData();
    } else {
      await this.loadData();
    }
    this.isLoading = false;
    if (!this.currentBusiness) this.initUser();
    document.title = `Report - Pending Balance Letter`;
    // this.initUser();
    // console.log('this.$route.params', this.$route.meta)
  },
  components: { PrintViewBar },
  methods: {
    ...mapActions("global", ["initUser"]),
    viewInvoice(invoice) {
      const hashId = hashids.encode(invoice.id);
      let routeData = null;
      if (this.$route.meta.public) {
        routeData = this.$router.resolve({
          path: `/public/invoice/${hashId}/view`,
        });
      } else {
        routeData = this.$router.resolve({
          path: `/global/invoice/${hashId}/view`,
        });
      }

      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    getCustomer() {
      // const id = hashids.decode(this.$route.params.id);
      return customerService.getById(this.student.CustomerId).then((response) => {
        console.log('this.customer response', response)
        this.customer = response.data;

        if (this.customer.email) this.showEmailBtn = true;
      });
    },
    getStudents() {
      const id = hashids.decode(this.$route.params.id);
      // console.log('id', id)
      return studentService.getById(id[0]).then(async (response) => {
        console.log('this.students', response)
        this.student = response.data;
        this.title = this.student.fullName 
        // console.log('this.students', this.students)
        // this.classes = []
        await this.student.ClassStudents.map(async classStudent => {
          console.log('classStudent', classStudent)
          if (classStudent.fee != classStudent.parentPay) {
            const classInfo = (await classService.getById(classStudent.ClassId)).data
            console.log('classInfo', classInfo)
            this.currentClass = classInfo
            this.currentNotPayingClass = classStudent
          }

          //   let rowFound = this.classes.find(({ id }) => id == classStudent.ClassId);
          //   if(!rowFound)
          //     this.classes.push(classStudent.Class)
          // })
        })
      });
    },
    print() {
      window.print();
    },
    stripHTML(html) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      return tempElement.textContent || tempElement.innerText || '';
    },
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      const where = {
        CustomerId: id,
        due: true,
        key: key,
      };
      return invoiceService.getAll(where).then((response) => {
        // console.log("response invoice", response);
        this.$Progress.finish();
        this.Invoice = response.data;
      });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);

      const where = {
        CustomerId: id,
        due: true,
      };

      return invoiceService.getAll(where).then((response) => {
        console.log("invoice", response);
        this.Invoice = response.data;
        this.count = response.count;
        this.business = response.business;
        return response;
      });

    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
